/**
 * @generated SignedSource<<6e9511a099416dba219331b7daf88799>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BlocksBeforeVoteClosesRuleFragment$data = {
  readonly blocksBeforeVoteCloses: number;
  readonly " $fragmentType": "BlocksBeforeVoteClosesRuleFragment";
};
export type BlocksBeforeVoteClosesRuleFragment$key = {
  readonly " $data"?: BlocksBeforeVoteClosesRuleFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BlocksBeforeVoteClosesRuleFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BlocksBeforeVoteClosesRuleFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blocksBeforeVoteCloses",
      "storageKey": null
    }
  ],
  "type": "LiquidDelegationRules",
  "abstractKey": null
};

(node as any).hash = "38743ec9af7555382e1a1272bb30c5c3";

export default node;
